import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import SocialIcons from './subcomponents/SocialIcons';
import DarkModeToggle from './subcomponents/DarkmodeToggle';
import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

function Header({ componentsToShow }) {
  const { darkMode, toggleTheme } = useTheme();
  
  const iconStyle = {
    color: darkMode ? '#e0e0e0' : '#064689',
    fontSize: '1.5rem',
    margin: '0 0.25rem',
  };
  const location = useLocation();

  // Add scroll handler
  const handleScroll = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      const headerHeight = document.querySelector('.header').offsetHeight;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth'
      });
    }
  };

  // Check if the current path is "/"
  const isHomePage = location.pathname === '/';
  const navLinks = componentsToShow.map((component, index) => {
    // Convert component name to URL-friendly format for the ID
    const sectionId = component.name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    return (
      <li key={index}>
        <a 
          href={`#${sectionId}`}
          onClick={(e) => handleScroll(e, sectionId)}
        >
          {component.name}
        </a>
      </li>
    );
  });
  
  return (
    <header className={`header ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="left-content">
        <div className="logo">Lukas Schulte</div>
        <SocialIcons darkMode={darkMode} />
      </div>
      <div className="right-content">
        {isHomePage ? (
          <nav>
            <ul className="nav-links">
              {navLinks}
            </ul>
          </nav>
        ) : (
          <Link to="/" className="home-button">
            <FaHome style={iconStyle} />
          </Link>
        )}
        <DarkModeToggle darkMode={darkMode} toggleDarkMode={toggleTheme} />
      </div>
    </header>
  );
}

export default Header;